module.exports = __webpack_public_path__ + "img/metal_za@2x.dd6fcd71.png";